import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 引入微信 JSSDK
const wxSdkScript = document.createElement('script')
wxSdkScript.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
document.head.appendChild(wxSdkScript)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
